import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { getNotice, updateNotice } from '../../../api/boardNotice.api';
import Editor from '../../../components/board/notice/Editor';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetNotice } from '../../../models/boardNotice.model';

interface IMatch {
  noticeCode: string;
}

const BoardNoticeEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const noticeCode = Number(match.params.noticeCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetNotice>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (noticeCode) execute(getNotice(noticeCode));
  }, [noticeCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/board/notice${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!noticeCode) return;
    submitExecute(updateNotice(noticeCode, data));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-board-big.svg"
        parentMenu={t('common.menu.board')}
        currentMenu={t('board.notice.title5')}
      />
      <Editor
        notice={res?.data}
        onSubmit={submit}
      />
    </div>
  );
};

export default BoardNoticeEdit;
